<template lang="pug">
modal(
  :no-footer='true'
  :title='$t("modal.birdIDTrialEmissionModal.title")'
  ref='modal'
  size='sm'
)
  p {{ $t('modal.birdIDTrialEmissionModal.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/safe-screen.svg')
  .text-center.mt-5
    .d-flex.justify-content-end.gap-4
      button.btn.btn-primary.text-nowrap(
        @click='birdIdTrialEmission()'
        style='border-width: 1px'
        type='button'
      )
        span.text {{ $t('modal.birdIDTrialEmissionModal.buttonLabel') }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';
import config from '@/config';

export default {
  name: 'BirdIdTrialEmissionModal',
  components: {
    Icon,
    Modal,
  },
  created() {
    this.birdIdTrialEmissionUrl = config.birdIdTrialEmission;
  },
  data() {
    return {
      birdIdTrialEmissionUrl: '',
    };
  },
  methods: {
    birdIdTrialEmission() {
      this.$emit('bird-id-trial-emission', this.birdIdTrialEmissionUrl);
      this.$refs.modal.close();
    },
  },
};
</script>

<style scoped lang="stylus">
p
  font-size: 16px
  line-height: 24px
img
  margin: 32px
  width: 184.371px
  height: 155px
  flex-shrink: 0
button
  padding: 8px
  display: flex
  flex-direction: row
</style>
